import { z } from 'zod';
/**
 * Rush Hour — spatial planning.
 *
 * A 6x6 grid of cars. Cars are 1xN (horizontal) or Nx1 (vertical) and slide only
 * along their axis. The red target car must reach the exit on the right edge.
 * Solved when the target car's front reaches the exit.
 *
 * The client sends "move car K by delta along its axis"; the server validates
 * the slide is unobstructed and in-bounds.
 */
export const RUSH_SIZE = 6;
/** The target car's row (0-indexed). The exit is the right edge of this row. */
export const RUSH_EXIT_ROW = 2;
export const RushMoveEvent = z.object({
    type: z.literal('move'),
    /** Index of the car to move. */
    car: z.number().int().min(0).max(31),
    /** Signed steps along the car's axis. Negative = left/up, positive = right/down. */
    delta: z.number().int().min(-5).max(5),
});
export const RushEvent = z.discriminatedUnion('type', [RushMoveEvent]);
//# sourceMappingURL=rush-hour.js.map